
import { RegisterForm } from "./RegisterForm";
import { InterestedStudies } from "./InterestedStudies";
import { InterestedStudiesContact } from "./InterestedStudiesContact";
import { Students } from "./Students";
import { SearchFilters } from "./SearchFilters";
import { SearchResults } from "./SearchResults";
import { ProfileCard } from "./ProfileCard";
import { ProfileFavorites } from "./ProfileFavorites";
import { AcceptanceChances } from "./AcceptanceChances";
import { SuitabilityCalc } from "./SuitabilityCalc";
import SearchBar from "./SearchBar";
import Registration from './Registration';
import { FavoriteButtonsWrapper } from "./FavoriteButtonsWrapper";
import GlobalSearchResults from "./GlobalSearchResults";
import { AdmissionReqGraph } from "./AdmissionReqGraph";
import { TripleCalc } from "./TripleCalc";
import {GeneralSearch} from "./GeneralSearch";
import {DetailsForm} from "./DetailsForm";



registerWidget('InterestedStudies', InterestedStudies);
registerWidget('InterestedStudiesContact', InterestedStudiesContact);
registerWidget('RegisterForm', RegisterForm);
registerWidget('students', Students);
registerWidget('SearchFilters', SearchFilters);
registerWidget('SearchResults', SearchResults);
registerWidget('ProfileCard', ProfileCard);
registerWidget('ProfileFavorites', ProfileFavorites);
registerWidget('AcceptanceChances', AcceptanceChances);
registerWidget('SuitabilityCalc', SuitabilityCalc);
registerWidget('SearchBar', SearchBar);
registerWidget('Registration', Registration)
registerWidget('GlobalSearchResults', GlobalSearchResults);
registerWidget('Registration', Registration);
registerWidget('FavoriteButtonsWrapper', FavoriteButtonsWrapper);
registerWidget('AdmissionReqGraph', AdmissionReqGraph);
registerWidget('thirdCalc', TripleCalc);
registerWidget('GeneralSearch', GeneralSearch);
registerWidget('DetailsForm', DetailsForm);

//

